import { api } from "../client";

export const getComplianceRecord = (user, startDate, endDate) => {
  return api.get(
    `/compliance?email=${user}&startDate=${startDate}&endDate=${endDate}&include=true`
  );
};
